import { dispatchAction } from '@ardoq/rxbeach';
import {
  panSettle,
  setCenter,
  setFocusState,
  setHoverState,
  setScale,
} from './actions';
import { BubbleChartInteractionCommands } from './types';

export const defaultBubbleChartCommands: BubbleChartInteractionCommands = {
  updateHoverState: (hoverState, viewInstanceId) =>
    dispatchAction(setHoverState(hoverState), viewInstanceId),
  updateFocusState: (focusState, viewInstanceId) =>
    dispatchAction(setFocusState(focusState), viewInstanceId),
  setCenter: (windowCenter, viewInstanceId) =>
    dispatchAction(setCenter(windowCenter), viewInstanceId),
  setScale: (state, viewInstanceId) =>
    dispatchAction(setScale(state), viewInstanceId),
  panSettle: viewInstanceId => dispatchAction(panSettle(), viewInstanceId),
};
